// @ts-nocheck - Legacy file with extensive type issues requiring comprehensive refactoring (TODO: GXM-XXXX)
import { Link, useLocation } from "react-router-dom";
import { getName } from "country-list";
import ReactCountryFlag from "react-country-flag";
import { Skeleton } from "primereact/skeleton";
import Layout from "~/Layout";
import { TabPanel, TabView } from "primereact/tabview";
import useAppointmentsAndOwnership from "./useAppointmentsAndOwnership";
import DirectorTab from "./DirectorTab";
import ShareHolderTab from "./ShareHolderTab";
import OfficersAttornyRegistryTab from "./OfficersAttornyRegistryTab";
import "./style.scss";
import "../Officers/officers-attorny.scss";
import "../../components/share-holders/share-holders.scss";
import "../../components/share-holders/shareholder-form.scss";
import ToastMessage from "~/components/ToastMessage";
import { useEffect, useRef } from "react";
import { Toast } from "primereact/toast";

const AppointmentsAndOwnership = () => {
  const location = useLocation();
  const {
    id,
    entityData,
    pageLoading,
    tabIndex,
    handleTabChange,
    directorsArr,
    isLoading,
    handleAddDirector,
    shareHolders,
    handleAddShareholder,
    hasEntityPlusAccess,
    refetchShareholders,
    refetchDirectors,
  } = useAppointmentsAndOwnership();
  const tables = {
    0: (
      <DirectorTab
        directorsArr={directorsArr}
        loading={isLoading}
        onDirectorClick={handleAddDirector}
      />
    ),
    1: (
      <ShareHolderTab
        shareholderArr={shareHolders}
        onAddShareholderClick={handleAddShareholder}
        shareLoading={isLoading}
        refetchShareholders={refetchShareholders}
      />
    ),
    ...(hasEntityPlusAccess && {
      2: <OfficersAttornyRegistryTab type={"officer"} />,
      3: <OfficersAttornyRegistryTab type={"power-of-attorney"} />,
    }),
  };
  const toastRef = useRef<Toast>(null);
  const toastShownRef = useRef(false);

  // check if this page is mounted after deletion of director/shareholder (show toast only once)
  useEffect(() => {
    const hasDirectorState =
      location.state?.hasDeleted && location.state?.deletedProfile;
    const hasShareholderState = location.state?.shareholderRemovedFromEntity;

    if (!hasDirectorState && !hasShareholderState) {
      toastShownRef.current = false;
      return;
    }

    if (hasDirectorState) {
      if (!toastShownRef.current && toastRef.current) {
        toastShownRef.current = true;
        const { type, first_name, last_name } = location.state.deletedProfile;
        const isRemovedFromEntity = location.state?.directorRemovedFromEntity;
        const entityName =
          (location.state?.entityName && location.state.entityName.trim()) ||
          entityData?.name ||
          "the entity";
        toastRef.current.show({
          severity: "error",
          summary: isRemovedFromEntity
            ? "Removed from entity"
            : "Profile Deleted. ",
          detail: isRemovedFromEntity
            ? `The Director ${[first_name, last_name].filter(Boolean).join(" ").trim() || "Unknown"} was removed from the entity ${entityName} as there are no appointments linked to this profile`
            : `The ${type}’s profile “${first_name} ${last_name}” was deleted.`,
          icon: isRemovedFromEntity ? "pi pi-info-circle" : "pi pi-trash",
          life: isRemovedFromEntity ? 3000 : 5000,
        });
      }
      refetchDirectors();
      window.history.replaceState({}, document.title);
    } else if (hasShareholderState) {
      if (!toastShownRef.current && toastRef.current) {
        toastShownRef.current = true;
        const name = location.state?.shareholderName ?? "Unknown";
        const entityName =
          (location.state?.entityIdRemovedFrom === id && entityData?.name) ||
          (location.state?.entityName && location.state.entityName.trim()) ||
          entityData?.name ||
          "the entity";
        toastRef.current.show({
          severity: "error",
          summary: "Removed from entity",
          detail: `The shareholder ${name} was removed from the entity ${entityName} as they no longer hold any share transactions associated with it`,
          icon: "pi pi-info-circle",
          life: 3000,
        });
      }
      refetchShareholders();
      window.history.replaceState({}, document.title);
    }
  }, [location.state, refetchShareholders, refetchDirectors, entityData?.name]);
  return (
    <Layout
      crumbs={[
        {
          label: (
            <Link to="/entities" className="link__style">
              My Entities
            </Link>
          ),
          id: "entities",
        },
        {
          label: (
            <Link to={`/entity/${id}/dashboard`} className="link__style flex">
              {!pageLoading ? entityData?.name : <Skeleton width="100px" />}
              {!pageLoading && (
                <>
                  {" ("}
                  <ReactCountryFlag
                    countryCode={entityData?.country || ""}
                    svg
                  />{" "}
                  {getName(entityData?.country || "")})
                </>
              )}
            </Link>
          ),
          id: "entity",
        },
        { label: "Appointments & Ownership", id: "appointments-and-ownership" },
      ]}
    >
      <h1 className="heading">Appointments & Ownership</h1>
      <p className="description">
        Schedule and manage appointments related to this entity. Track changes
        in ownership and view the current ownership structure
      </p>

      <div className="inline-flex">
        <TabView
          activeIndex={tabIndex}
          onTabChange={handleTabChange}
          className="appointments-ownership-tabs"
        >
          <TabPanel header="Directors" />
          <TabPanel header="Shareholders" />
          {hasEntityPlusAccess && <TabPanel header="Officers" />}
          {hasEntityPlusAccess && <TabPanel header="Power of Attorneys" />}
        </TabView>
      </div>
      {tables[tabIndex]}
      <ToastMessage ref={toastRef} />
    </Layout>
  );
};

export default AppointmentsAndOwnership;
